import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PaidFeatureUpsellModalConfig, PaidFeatureUpsellModalRow, PaidFeatureUpsellService } from '../../../services/paid.feature.upsell.service';

@Component({
    selector: 'paid-feature-upsell-modal',
    template: require('./paid.feature.upsell.component.html'),
    styles: [require('./paid.feature.upsell.component.css')]
})
export class PaidFeatureUpsellComponent implements OnInit, OnDestroy {
    readonly modalId = 'paid-feature-upsell-modal';
    config: PaidFeatureUpsellModalConfig;
    private modalSubscription: Subscription;

    constructor(private readonly paidFeatureUpsellService: PaidFeatureUpsellService) {
    }

    ngOnInit() {
        this.modalSubscription = this.paidFeatureUpsellService.modalState$.subscribe(config => {
            this.config = config;
            $(`#${this.modalId}`).modal();
        });
    }

    ngOnDestroy() {
        if (this.modalSubscription) {
            this.modalSubscription.unsubscribe();
        }

        $(`#${this.modalId}`).modal('hide');
    }

    close() {
        $(`#${this.modalId}`).modal('hide');
    }

    onPrimaryAction() {
        this.close();
        this.paidFeatureUpsellService.navigateToPrimaryAction(this.config);
    }

    trackByRow(index: number, row: PaidFeatureUpsellModalRow) {
        return row.label;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/paid.feature.upsell/paid.feature.upsell.component.ts